



































































































































































import Vue from "vue";
import PostView from "../views/PostView.vue";
import LoginForm from "../components/user/LoginForm.vue";
import SignupForm from "../components/user/SignupForm.vue";
import SideNavbar from "../components/SideNavbar.vue";

export default Vue.extend({
  name: "Navbar",

  components: {
    PostView,
    LoginForm,
    SignupForm,
    SideNavbar,
  },
  data: () => ({
    links: [
      {
        name: "경매",
        to: "/auction"
      },
    ],
    // Sidebar active
    active: false,
    nickname: "",
    dialog: false,
    dialogLogin: false,
    pleaseLogin: false,
    dialogSignup: false,
    message: "이 필요한 서비스입니다.🐯",
    searchData: "",
    
    alarmCount: 5,
  }),
  computed: {
    login (): string {
      return this.$store.state.userModule.status.loggedIn;
    },
  },
  watch: {
    login () {
      if (this.login) {
        this.getNickname();
        this.dialogLogin = false;
      }
    }
  },
  mounted (): void {
    if (this.login) {
      this.getNickname();
    };
  },
  methods: {
    logout (): void {
      this.$store.dispatch("userModule/logout");
      this.$router.push({ path: '/' });
    },
    getNickname (): void {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      this.nickname = user.object.user.nickname;
    },
    search () {
      this.$store.dispatch("auctionModule/search", this.searchData);
      this.searchData = "";
      if (this.$router.currentRoute.name !== "Auction") {
        this.$router.push({ name: "Auction" });
      };
    }
  }
});
